import { ShoppingCartSimpleIcon as PhosphorShoppingCartSimpleIcon } from "@phosphor-icons/react/dist/ssr/ShoppingCartSimple";

import { createAppIcon } from "@/components/createAppIcon";

export const RemoveFromCartIcon = /* @__PURE__ */ createAppIcon(PhosphorShoppingCartSimpleIcon);
